export default __webpack_public_path__ + "static/media/nav-admin-settings-outline.591868b1.svg";